/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EraseIcon = ({ width = 24, height = 24, hidden = false, title = 'Erase' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.18359,5.86816l-3.6875-3.6875c-.84961-.84961-2.3335-.84961-3.18213,0L1.81641,11.67773c-.87598.87598-.87695,2.30176-.00244,3.17871l2.48242,2.49121s.00049,0,.00049.00098c.41943.41992,1.00049.66113,1.59326.66113h2.40527c.59229,0,1.17188-.24023,1.59082-.65918l8.29834-8.30078c.87646-.87793.87598-2.30469-.00098-3.18164ZM8.82568,16.29004c-.13965.13965-.33301.21973-.53027.21973h-2.40527c-.19727,0-.39111-.08008-.53125-.2207l-2.48291-2.49121c-.29102-.29297-.29102-.76758.00098-1.05957l2.63635-2.63623,4.58923,4.58936c.05701.05713.125.09351.19305.12817l-1.46991,1.47046ZM17.12354,7.98926l-5.8324,5.83447c-.03479-.06812-.07111-.13599-.12805-.19287l-4.58917-4.58911,5.80109-5.80054c.28223-.2832.77686-.2832,1.06006,0l3.68799,3.6875c.29248.29199.29248.76855.00049,1.06055Z"
      fill="currentColor"
    />
    <path
      d="M17.93652,18.02148h-.43652c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h.43652c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M15.00586,18.02148h-2.50586c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h2.50586c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
  </svg>`;
};
